export const getters = {
  getUserId(state) {
    return state.userId;
  },
  getQuestion(state) {
    return state.question;
  },
  getWrongEmail(state) {
    return state.wrongEmail;
  },
  getInsuranceQuestions(state) {
    return state.insuranceQuestions;
  },
  getToken(state) {
    return state.token;
  },
  getResetToken(state) {
    return state.resetToken;
  },
  getResetTokenVerified(state) {
    return state.resetTokenVerified;
  }
};
